module.exports = __webpack_public_path__ + "static/media/terms-condition-banner-mtn.2b2cc2e5.png";